import { render, staticRenderFns } from "./userInform.vue?vue&type=template&id=5036b57e&"
import script from "@viewJs/home/userInform.js?vue&type=script&lang=js&"
export * from "@viewJs/home/userInform.js?vue&type=script&lang=js&"
import style0 from "./userInform.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports